var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-core-columns"},_vm._l((_vm.block.innerBlocks),function(column,i){return _c('div',{key:i,staticClass:"single-column",style:('width:' +
				(column.attrs.width ? column.attrs.width : _vm.defaultWidth) +
				(column.attrs.width && column.attrs.width.indexOf('%') > -1 ? '' : '%'))},[_c('RenderBlocks',{attrs:{"blocks":column.innerBlocks,"parentBlock":_vm.parentBlock}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }